import { CircularProgress, HStack, Text } from '@chakra-ui/react'
import { useApp } from '@hb/react'
import { colors, ThreadType } from '@hb/shared'
import { useProfile } from '../../../../contexts/user/ProfileContext'
import { ThreadPopover } from '../../../Messaging/ThreadPopover'

export const PatientThreadView = () => {
  const { userId, user } = useProfile()
  const { appName } = useApp()
  if (appName === 'providers-app') {
    return null
  }
  return userId && user ? (
    <ThreadPopover
      id={userId}
      threadType={ThreadType.PATIENT}
      unreadThreadMessages={user?.unreadThreadMessages ?? 0}
    />
  ) : (
    <HStack>
      <CircularProgress color={colors.green.hex} isIndeterminate size={4} />
      <Text fontSize="sm" color="gray.500">
        Loading patient thread...
      </Text>
    </HStack>
  )
}
